import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from '@material-ui/core';
import Error from '@material-ui/icons/Error';
import Warning from '@material-ui/icons/Warning';
import { useEntity } from '@backstage/plugin-catalog-react';
import { validateCatalogEntity, ValidationError } from '../../utils/entityValidation';

const EntityValidationPanel = () => {
  const { entity } = useEntity();
  const errors = validateCatalogEntity(entity);

  if (errors.length === 0) {
    return null;
  }

  const errorItems = errors.filter(e => e.severity === 'error');
  const warningItems = errors.filter(e => e.severity === 'warning');

  return (
    <Box>
      {errorItems.length > 0 && (
        <Paper
          elevation={0}
          style={{
            marginBottom: warningItems.length > 0 ? 16 : 0,
            backgroundColor: '#ffebee',
            borderLeft: '4px solid #f44336',
            padding: '16px',
          }}
        >
          <Box display="flex" alignItems="center" marginBottom={2}>
            <Error style={{ color: '#f44336', marginRight: '8px' }} />
            <Typography variant="h6" style={{ color: '#c62828', fontWeight: 600 }}>
              Catalog Validation Errors ({errorItems.length})
            </Typography>
          </Box>
          <List dense disablePadding>
            {errorItems.map((error: ValidationError, index: number) => (
              <ListItem key={`error-${index}`} disableGutters>
                <ListItemIcon style={{ minWidth: 36 }}>
                  <Error fontSize="small" style={{ color: '#f44336' }} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="body2" component="span" style={{ color: '#c62828' }}>
                      <strong>{error.path}:</strong> {error.message}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}

      {warningItems.length > 0 && (
        <Paper
          elevation={0}
          style={{
            backgroundColor: '#fff3e0',
            borderLeft: '4px solid #ff9800',
            padding: '16px',
          }}
        >
          <Box display="flex" alignItems="center" marginBottom={2}>
            <Warning style={{ color: '#ff9800', marginRight: '8px' }} />
            <Typography variant="h6" style={{ color: '#e65100', fontWeight: 600 }}>
              Catalog Validation Warnings ({warningItems.length})
            </Typography>
          </Box>
          <List dense disablePadding>
            {warningItems.map((warning: ValidationError, index: number) => (
              <ListItem key={`warning-${index}`} disableGutters>
                <ListItemIcon style={{ minWidth: 36 }}>
                  <Warning fontSize="small" style={{ color: '#ff9800' }} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="body2" component="span" style={{ color: '#e65100' }}>
                      <strong>{warning.path}:</strong> {warning.message}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  );
};

export default EntityValidationPanel;

